import { Modal } from 'reactstrap';

const VatInfoModal = ({
    isOpen,
    toggle
}) => {
    return (
        <Modal
            isOpen={isOpen}
            centered
            className="cm_g_modal_wrapper"
        >
            <div className='cm_g_modal_header'>
                <h3>VAT & GST</h3>
                <span onClick={toggle}>
                    <i className='fa-solid fa-xmark'></i>
                </span>
            </div>

            <div className='cm_g_modal_body'>
                <div className='cm_g_modal_body_mx_height'>
                    <div className='d-flex gap-3 align-items-center'>
                        <div>
                            <span className='bg_icon_g'><i className='fa-solid fa-circle-info'></i></span>
                        </div>
                        <div className='w-full'>
                            <h5 className='m-0'>What is VAT?</h5>
                        </div>
                    </div>
                    <p className='mt-3'>
                        Value Added Tax (VAT) is a consumption tax that's added to the price of goods and services.
                        It's collected at each stage of the supply chain where value is added.
                    </p>

                    <div className='d-flex gap-3 align-items-center'>
                        <div>
                            <span className='bg_icon_g'><i className='fa-solid fa-circle-info'></i></span>
                        </div>
                        <div className='w-full'>
                            <h5 className='m-0'>What is GST?</h5>
                        </div>
                    </div>
                    <p className='mt-3'>
                        Goods and Services Tax (GST) is a consumption tax added to the value of goods or services purchased.
                    </p>

                    <div className='d-flex gap-3 align-items-center'>
                        <div>
                            <span className='bg_icon_g'><i className='fa-solid fa-gears'></i></span>
                        </div>
                        <div className='w-full'>
                            <h5 className='m-0'>How We Handle VAT/GST</h5>
                        </div>
                    </div>
                    <p className='mt-3'>We act as the merchant of record for all transactions on our platform, which means we manage VAT/GST calculations for you. Here's how it works:</p>

                    <ul className='cm_ll'>
                        <li>We calculate the correct VAT/GST (or local sales tax) at checkout based on the buyers country and the final price buyers see already includes any applicable tax</li>
                        <li>If you're VAT/GST registered and have added your VAT/GST number your daily and monthly earning reports will display your VAT/GST number along with the amount remitted</li>
                        <li>Once you add your VAT/GST number you can declare the VAT/GST remitted as output tax and depending on your local regulations you may be able to offset it against input tax on eligible business expenses</li>
                        <li>For any sales made while your VAT or GST number was not provided, “VAT not applicable” or “GST not applicable” will appear on your earnings reports. You will be responsible for reviewing your transaction history, calculating any VAT or GST that should have been applied, and including it in your next return</li>
                    </ul>

                    <div className='d-flex gap-3 align-items-center'>
                        <div>
                            <span className='bg_icon_g'><i className='fa-solid fa-building'></i></span>
                        </div>
                        <div className='w-full'>
                            <h5 className='m-0'>Tax Authority Remittance</h5>
                        </div>
                    </div>
                    <p className='mt-3'>
                        Juicy House collects VAT/GST at checkout based on the buyer's location and remits it to the appropriate tax authorities. You are responsible for declaring VAT/GST using the amounts shown in your earnings reports. Depending on local regulations, this may be treated as output tax and offset against your business expenses.
                    </p>
                    <p className='mt-3'>
                        You can export earnings reports for the selected year by tapping Export Data at the bottom of the Earnings & Payouts screen.
                    </p>

                    <div className="d-flex gap-3 mb-4 notice_card important_notice_card_dark">
                        <div>
                            <i className='fa-solid fa-triangle-exclamation'></i>
                        </div>
                        <div className="w-full">
                            <h4>Important Note</h4>
                            <p>VAT/GST rates and regulations may change. We automatically update our system to reflect current rates and ensure compliance.</p>
                        </div>
                    </div>
                </div>

                <span
                    onClick={toggle}
                    className='btn btn_primary w-full mt-3'
                >
                    Got it
                </span>
            </div>
        </Modal>
    );
};

export default VatInfoModal;

